export const MenuButtonText = (props: any) => {
  const {
    isHighlighted,
    padding = undefined,
    color = undefined,
    fontWeight = undefined,
    wordBreak = undefined,
    tooltip,
  } = props;

  return (
    <span
      style={{
        flex: 1,
        textAlign: "left",
        padding: padding,
        color: color,
        fontWeight: fontWeight,
        wordBreak: wordBreak,
      }}
    >
      {tooltip}
    </span>
  );
};
